/* DENSA — SEKME BASLIGI v2.1 (15 Agu 2026)
   Kurucu istegi: site misafiri baska sekmeye gectiginde baslikta bir hatirlatma dursun.

   v2.1 (kurucu bildirimi: "takila takila kayiyor, daha akici kayamaz mi?"):
   KOK NEDEN — kayma ancak sekme ARKA PLANDAYKEN calisir; tarayicilar arka plan sekmelerinin
   zamanlayicilarini bilerek kisar (Chrome: en az 1 sn/adim; 5 dk sonra 1 dk/adim). 320ms'lik
   adim istegimiz ne olursa olsun 1 sn'ye ezilir -> harf harf, takilarak akar. Satis noktalari
   bandindaki akicilik CSS animasyonudur ve GORUNUR sayfada calisir; sekme basliginda karsiligi
   YOKTUR (baslik piksel degil metindir, en kucuk adim bir harftir).
   COZUM — kaydirmayi hizlandirmak degil, kaydirmaya ihtiyac birakmamak: bos-sepet mesaji
   34 karaktere indirildi ('Aromaterapi Rituelinize Devam Edin' = tam 34), esige sigar, SABIT
   durur. Dolu-sepet mesaji zaten sigar ('Sepetinizde 99 urun sizi bekliyor' = 33). Kayma kodu
   guvenlik agi olarak duruyor: ileride biri uzun mesaj yazarsa yine devreye girer.

   v2.0 (kurucu karari): sepet doluysa sayi yazilir; Turkcede sayidan sonra cogul eki yok.
   Onceki 'Acele yok, buradayiz.' begenilmedi. Kaydirma yalniz sekme arkadayken; geri donulunce
   eski baslik aynen gelir (SEO ve paylasim basligi etkilenmez).
   Sepet sayisi Liquid'den gelir; ilk gizlenmede bir kez /cart.js ile tazelenir.
   Yukleme noktasi: snippets/densa-istek.liquid (site geneli). */
(function () {
  var MESAJ_BOS   = 'Aromaterapi Ritüelinize Devam Edin';
  var MESAJ_DOLU  = 'Sepetinizde {n} ürün sizi bekliyor';
  var KAYMA_ESIGI = 34;
  var KAYMA_HIZI  = 320;

  var asilBaslik = document.title;
  var adet = (window.densaSepetAdedi != null) ? window.densaSepetAdedi : 0;
  var tazelendi = false;
  var zamanlayici = null;

  function mesaj() {
    return adet > 0 ? MESAJ_DOLU.replace('{n}', adet) : MESAJ_BOS;
  }

  function kaymayiDurdur() {
    if (zamanlayici) { clearInterval(zamanlayici); zamanlayici = null; }
  }

  function basligiKur() {
    kaymayiDurdur();
    var m = mesaj();
    if (m.length <= KAYMA_ESIGI) { document.title = m; return; }
    var serit = m + '   ·   ';
    var i = 0;
    document.title = serit.slice(0, KAYMA_ESIGI);
    zamanlayici = setInterval(function () {
      if (!document.hidden) { kaymayiDurdur(); return; }
      i = (i + 1) % serit.length;
      var gorunen = (serit + serit).substr(i, KAYMA_ESIGI);
      document.title = gorunen;
    }, KAYMA_HIZI);
  }

  function sepetiTazele() {
    if (tazelendi || typeof fetch !== 'function') return;
    tazelendi = true;
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (y) { return y.ok ? y.json() : null; })
        .then(function (s) {
          if (!s) return;
          adet = s.item_count || 0;
          if (document.hidden) basligiKur();
        })
        .catch(function () {});
    } catch (h) {}
  }

  function bizimMesajimizMi(t) {
    if (!t) return false;
    if (t === MESAJ_BOS) return true;
    if (t.indexOf('Sepetinizde') === 0) return true;
    /* kayan halde parca gosterilir; kok kelimelerden tani (Ritüeliniz* iki mesaji da kapsar) */
    return t.indexOf('Ritüeliniz') > -1 || t.indexOf('ürün sizi bekliyor') > -1;
  }

  document.addEventListener('visibilitychange', function () {
    try {
      if (document.hidden) {
        if (!bizimMesajimizMi(document.title)) asilBaslik = document.title;
        basligiKur();
        sepetiTazele();
      } else {
        kaymayiDurdur();
        document.title = asilBaslik;
      }
    } catch (h) {}
  });

  window.addEventListener('pageshow', function () {
    try { if (!document.hidden) { kaymayiDurdur(); document.title = asilBaslik; } } catch (h) {}
  });
})();